import { Spinner } from '@/components/ui'

export function FullScreenSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <Spinner size="lg" />
    </div>
  )
}
